import React, { useMemo } from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const Page9 = () => (
<section
  id="page9"
  className="min-h-screen w-full flex flex-col md:flex-row items-stretch p-0 md:p-0 bg-brand-black overflow-visible lg:h-screen lg:overflow-hidden"
  
> 


  
  
  <div className="w-full md:h-full flex flex-col justify-center px-8 py-10 md:py-0">
  <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-2xl sm:text-[32px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}>                <p className="block justify-center px-6 sm:px-10 md:px-24 lg:px-[200px]" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "2",}}>
                    
                    ما در حال <span style={{color:"#ffd299"}} >رشد</span> اکوسیستمی برای <span style={{color:"#ffd299"}} >نسل جدید متخصصان</span>   هستیم ; جایی که تخصص واقعی به فرصت های واقعی <span style={{color:"#ffd299"}} >متصل</span>  می شود.

                </p>
                </AnimatedElement>
        <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-sm sm:text-[15px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}>                <p className="block justify-center px-6 sm:px-10 md:px-24 lg:px-[250px] font-normal " style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    
  fontWeight: 400,
    lineHeight: "3",}}>
                    
                    در این فضا ، متخصص مسیر حرفه ای خود را در یک شبکه زنده و پویا توسعه می دهد. ما با فراهم کردن دسترسی به پروژه های معتبر و ساختاری مستقل از سازمانهای ثابت ، بستری ایجاد می کنیم که متخصصان بتوانند جایگاه حرفه ای خود را ارتقاء دهند.
                </p>
                </AnimatedElement>
                <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-sm sm:text-[15px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}> 
  
                <p className="block justify-center px-6 sm:px-10 md:px-24 lg:px-[250px]" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "3",}}>
                    
                    همکاری برای ما فقط پروژه نیست. هر متخصص در جریان کار به شبکه ای از افراد ، تجربه ها و فرصت های واقعی متصل می شود ; جریانی که رشد حرفه ای را طبیعی و پایدار می کند.
                    </p>

                    </AnimatedElement>
                    <AnimatedElement
  delay={0.9}
  className="text-right px-8 text-white  leading-8 text-sm sm:text-[15px]"
  style={{
    direction: "rtl",
    textAlign: "justify",
    textJustify: "inter-word",
  }}> 

                <p className="block justify-center px-6 sm:px-10 md:px-24 lg:px-[250px]" style={{     direction: "rtl",
    textAlign: "justify",
    textAlignLast: "right",
    fontFamily: "pinar",
    lineHeight: "3",}}>
                    
نتیجه این رویکرد پروژه هایی است که به جای وابستگی به یک فرد ، بر یک شبکه حرفه ای تکیه دارند ; جایی که کیفیت ، تخصص و خلاقیت بصورت همزمان تقویت می شود.                    
                    
                    </p>

            </AnimatedElement>
            </div>
   
</section>
);

  


export default Page9;



